'use strict';

var trackingUtils = require('../modules/utils/tracking.utils');
const openedClass = function() {
    return Odigeo.AB.isCssVariationHeaderDesktop ? 'opened prisma-btn-active' : 'opened';
};
Odigeo.defineWidget('country_links', Odigeo.Widget.extend({
    modelClass: Odigeo.Model.extend({
        defaults: {
            continentItems: [],
        },
        isEmptyData: false,
        url: Odigeo.Settings.getProperty('countryLinksServiceUrlFormatter'),

        getDataRequestSettings: function() {
            return {
                success: Odigeo._.bind(function(data) {
                    this.addLanguage(data);
                    this.set(data);
                }, this),
            };
        },

        addLanguage: function(data) {
            data.language = data.websiteId.length > 2 ? data.websiteId.substring(2, 4) : data.websiteId;
        },
    }),

    viewClass: Odigeo.View.extend({
        selectors: {
            headerLauncher: '.header_launcher',
            closeButton: '.header_tooltip_close',
            countryLink: '.country_link',
            internationalLink: '.international_site_link',
            continentHeader: '.continent_header',
            continentContent: '.continent_content',

        },

        events: {
            'tap @countryLink': 'onCountryLinkClick',
            'tap @internationalLink': 'onInternationalLinkClick',
            'tap @closeButton': 'onClose',
            'tap @continentHeader': 'onAccordion',
            'tap @headerLauncher': 'onOpen',
        },

        init: function() {
            this.listenTo(this.widget.model, 'change', this.render);
        },

        render: function() {
            if (!Odigeo.AB.isCssVariationHeaderDesktop) {
                this.setTemplate(this.$el, 'countryLinks', this.model.toJSON());
            } else {
                var dataSet = Odigeo.Utils.parseJson(document.querySelector('#country-links').dataset.countryselectorconfig);
                this.setTemplate(this.$el, 'countryLinks', JSON.stringify(dataSet));
            }
            this.addDomSelectorsToCache();
        },

        onOpen: function(e) {
            e.stopPropagation();
            Odigeo.UIElements.hint.hideAllHints();
            if (Odigeo.AB.isCssVariationHeaderDesktop) {
                const isNotDisplayed = !this.$cachedSelectors.headerLauncher.hasClass(openedClass());
                $('.header_menu_list').find('.opened').not('.prevent_close_on_tap').removeClass(openedClass());
                if (isNotDisplayed) {
                    this.$cachedSelectors.headerLauncher.addClass(openedClass());
                }
            } else {
                this.$cachedSelectors.headerLauncher.toggleClass(openedClass());
            }
            this.$el.find('.continent_header.unfolded').trigger(Odigeo.Events.tap);
        },

        onAccordion: function(e) {
            var $continentsHeaders = this.$cachedSelectors.continentHeader;
            var $continentsContents = this.$cachedSelectors.continentContent;

            var $el = $(e.target);
            var $content;
            var contentHeight;
            var $contentCountries;

            $continentsHeaders.removeClass('unfolded');
            $continentsContents.height(0);
            $el.closest('.continent_header').addClass('unfolded');

            $content = $continentsHeaders.filter('.unfolded').find(' + .continent_content');
            $contentCountries = $content.find('.continent_countries');
            contentHeight = $contentCountries.height();
            $content.height(contentHeight > 0 ? contentHeight : $($contentCountries.find('li')[0]).height());
        },

        onClose: function() {
            this.$cachedSelectors.headerLauncher.removeClass(openedClass());
        },

        onCountryLinkClick: function(e) {
            var countryLanguage = $(e.target).data('countryLabel');
            trackingUtils.trackEvent('header', 'language_' + countryLanguage, Odigeo.History.getPageNameFromFragment());
        },

        onInternationalLinkClick: function() {
            trackingUtils.trackEvent('header', 'language_international', Odigeo.History.getPageNameFromFragment());
        },

        beforeInsertTemplate: function(data) {
            var model;

            if (!Odigeo.AB.isCssVariationHeaderDesktop) {
                model = data || this.model.toJSON();
                model.continentItems = Odigeo._.chain(model.continentItems)
                    .filter('visibility')
                    .each(function(continent) {
                        var numCountries;
                        var mod;
                        continent.className = continent.defaultContinent ? 'unfolded' : '';
                        continent.countryDTOs = Odigeo._.chain(continent.countryDTOs)
                            .filter('visibility')
                            .each(function(country, index) {
                                country.hasLanguages = !!country.countryDTOs.length;
                                country.className = country.hasLanguages ? ' od-country-with-languages' : '';
                                country.className += index >= continent.indexLastLine ? ' od-country-last-row' : '';
                            })
                            .value();

                        numCountries = continent.countryDTOs.length;
                        mod = (numCountries % 3) || 3;
                        continent.indexLastLine = numCountries - mod;
                    })
                    .value();
                Odigeo._.last(model.continentItems).className += ' od-header-last-continent';
                model.showVisibility = this.$el.data('showvisibility');
            } else {
                var currentNation = this.$el.data('websitecode');
                var currentLang = this.$el.data('websitelang');
                model = Odigeo.Utils.parseJson(document.querySelector('#country-links').dataset.countryselectorconfig) || data || this.model.toJSON();

                model.continentItems = Odigeo._.chain(model.continentItems)
                    .each(function(continent) {
                        var numCountries;
                        var mod;
                        continent.className = '';
                        continent.countryDTOs = Odigeo._.chain(continent.countryDTOs)
                            .each(function(country, index) {
                                if (country.id === currentNation) {
                                    continent.className = 'unfolded';
                                }
                                country.hasLanguages = !!country.countryDTOs;
                                country.className = country.hasLanguages ? ' od-country-with-languages' : '';
                                country.className += index >= continent.indexLastLine ? ' od-country-last-row' : '';
                            })
                            .value();

                        numCountries = continent.countryDTOs.length;
                        mod = (numCountries % 3) || 3;
                        continent.indexLastLine = numCountries - mod;
                    })
                    .value();
                var lastContinent = Odigeo._.last(model.continentItems);
                if (lastContinent) {
                    lastContinent.className += ' od-header-last-continent';
                }
                model.language = currentLang.substring(0, 2).toUpperCase();
                model.nation = 2 < currentNation.length ? currentNation.substring(2, 4) : currentNation;
                model.showVisibility = this.$el.data('showvisibility');
            }

            return {
                model: model,
                cms: this.keys || {},
            };
        },

    }),
}));
